import { Modal } from '@material-ui/core';
import React from 'react';

const UOAVideoModal = ({ styles, onPlay, handleCloseVideo }) => {
  return (
    <Modal
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
      open={onPlay}
      onClose={handleCloseVideo}
    >
      <div style={styles.modalContent}>
        <iframe
          width="800"
          title="Intro Video"
          height="400"
          src="https://www.youtube.com/embed/lqqfcDh7QOA"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          style={styles.youtubeVideo}
        ></iframe>
      </div>
    </Modal>
  );
};
export default UOAVideoModal;



// WEBPACK FOOTER //
// ./src/Pages/UnusualOptionsActivity/components/tables/UOAVideoModel.jsx